import axios, { AxiosPromise } from 'axios';
import { ISalesPoint } from '../../../@types/model/masterData/salesPoint/salesPoint';


export default class SalesPointHttpService {
    public static getSalesPointData() : AxiosPromise<Array<ISalesPoint>> {
        return axios.get(`${API_URL}/v1/SalesPoint/GetAllWeb`);
    }

    public static addOrUpdateSalesPoint(data : ISalesPoint) : AxiosPromise<ISalesPoint> {
        return axios.post(`${API_URL}/v1/SalesPoint/PostSalesPoint`, data);
    }

    public static deleteSalesPoint(salesPointId : number) : AxiosPromise<ISalesPoint> {
        return axios.delete(`${API_URL}/v1/SalesPoint/Delete`, {
            params : { salesPointId },
        });
    }
}
